import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=aa0fa636"
import script from "./ship.vue?vue&type=script&lang=js"
export * from "./ship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports